"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rx = require("rxjs");
/**El mismo comportamiento que el debounce, pero cuando la promesa se resuelve inmediatamente, devuelve el valor de forma síncrona,
 * este comportamiento no lo tiene el debounce de RxJS, ya que si devuelves una promesa ya resuelta aún así el valor se pospone hasta el siguiente evento de JS
 *  */
function debounceSync(obs, timeFunc) {
    return new rx.Observable(function (subs) {
        var cancelar = false;
        /**Si hay un valor pendiente de reportar */
        var pendiente = undefined;
        var current = 0;
        var ReportarPendiente = function () {
            if (pendiente && !cancelar) {
                //Reportamos el ultimo valor si es que falta:
                subs.next(pendiente.x);
                pendiente = undefined;
            }
        };
        var ret = obs.subscribe(function (next) {
            if (cancelar)
                return;
            var promesaInmediata = true;
            current++;
            var currProm = current;
            var onPromise = function () {
                //Si esta promesa es vieja, no hace nada:
                if (currProm != current)
                    return;
                ///Llamamos inmediatamente al next
                ReportarPendiente();
            };
            pendiente = { x: next };
            var prom = timeFunc(next);
            prom.then(onPromise);
            //Si la ejecución del onPromise es después de este punto, la promesa no fue instantánea:
            promesaInmediata = false;
        }, function (error) {
            ReportarPendiente();
            subs.error(error);
            cancelar = true;
        }, function () {
            ReportarPendiente();
            subs.complete();
            cancelar = true;
        });
        return ret;
    });
}
exports.debounceSync = debounceSync;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVib3VuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZGVib3VuY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx5QkFBMkI7QUFFM0I7O01BRU07QUFDTixzQkFBZ0MsR0FBcUIsRUFBRSxRQUFxQztJQUN4RixPQUFPLElBQUksRUFBRSxDQUFDLFVBQVUsQ0FBQyxVQUFBLElBQUk7UUFDekIsSUFBSSxRQUFRLEdBQVksS0FBSyxDQUFDO1FBQzlCLDJDQUEyQztRQUMzQyxJQUFJLFNBQVMsR0FBeUIsU0FBUyxDQUFDO1FBQ2hELElBQUksT0FBTyxHQUFHLENBQUMsQ0FBQztRQUNoQixJQUFNLGlCQUFpQixHQUFHO1lBQ3RCLElBQUksU0FBUyxJQUFJLENBQUMsUUFBUSxFQUFFO2dCQUN4Qiw2Q0FBNkM7Z0JBQzdDLElBQUksQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDO2dCQUN2QixTQUFTLEdBQUcsU0FBUyxDQUFDO2FBQ3pCO1FBQ0wsQ0FBQyxDQUFDO1FBRUYsSUFBTSxHQUFHLEdBQUcsR0FBRyxDQUFDLFNBQVMsQ0FBQyxVQUFBLElBQUk7WUFDMUIsSUFBSSxRQUFRO2dCQUNSLE9BQU87WUFFWCxJQUFJLGdCQUFnQixHQUFHLElBQUksQ0FBQztZQUM1QixPQUFPLEVBQUUsQ0FBQztZQUNWLElBQU0sUUFBUSxHQUFHLE9BQU8sQ0FBQztZQUN6QixJQUFNLFNBQVMsR0FBRztnQkFDZCx5Q0FBeUM7Z0JBQ3pDLElBQUksUUFBUSxJQUFJLE9BQU87b0JBQ25CLE9BQU87Z0JBRVgsa0NBQWtDO2dCQUNsQyxpQkFBaUIsRUFBRSxDQUFDO1lBQ3hCLENBQUMsQ0FBQztZQUVGLFNBQVMsR0FBRyxFQUFFLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQztZQUN4QixJQUFNLElBQUksR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDNUIsSUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztZQUNyQix3RkFBd0Y7WUFDeEYsZ0JBQWdCLEdBQUcsS0FBSyxDQUFDO1FBRTdCLENBQUMsRUFBRSxVQUFBLEtBQUs7WUFDSixpQkFBaUIsRUFBRSxDQUFDO1lBQ3BCLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDbEIsUUFBUSxHQUFHLElBQUksQ0FBQztRQUNwQixDQUFDLEVBQUU7WUFDQyxpQkFBaUIsRUFBRSxDQUFDO1lBQ3BCLElBQUksQ0FBQyxRQUFRLEVBQUUsQ0FBQztZQUNoQixRQUFRLEdBQUcsSUFBSSxDQUFDO1FBQ3BCLENBQUMsQ0FBQyxDQUFDO1FBRUgsT0FBTyxHQUFHLENBQUM7SUFDZixDQUFDLENBQUMsQ0FBQztBQUNQLENBQUM7QUFoREQsb0NBZ0RDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/keautils/dist/debounce.js
// module id = 2275
// module chunks = 0